// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"paragraph___27pP7"};